<ng-container *ngIf="appInitialized">
  <img src='./assets/icons/logo-jll.png' alt="JLL Logo" class="logo">
  <top-main-navigation class="fixed-top"></top-main-navigation>
  <div class="main-area">
    <router-outlet class="main-content" *ngIf="!isIframe"></router-outlet>
  </div>
  <loading-indicator [show]="isLoading"></loading-indicator>
</ng-container>
